/**
 * Подсказки свободных ников при отказе `nick_taken` (Фаза 13, Эпик A2b, план §A2b).
 *
 * Отказ «ник занят» — не тупик: клиент предлагает 2–3 вариации введённого ника.
 * Кандидаты — ТОЛЬКО предложение интерфейса: занятость каждого подтверждает
 * сервер при повторном join (суффикс могли занять в момент выбора). Канон
 * занятости на сервере — `ToLower(TrimSpace)` (game.CanonNick), поэтому
 * кандидаты отличаются от исходного ника даже после канонизации.
 *
 * Длина: серверный санитайз обрезает ник до MaxNickLen=30; поле ввода игрока
 * ограничено 24 символами, но base приходит и из других источников — база
 * ужимается так, чтобы суффикс гарантированно сохранился.
 */

/** Совпадает с game.MaxNickLen (server): санитайз обрезает ник сверху. */
const MAX_NICK_LEN = 30;

/** Суффиксы-вариации: числовой в скобках, дефис, подчёркивание (план §A2b). */
const SUFFIXES = [' (2)', '-2', '_2'] as const;

/**
 * Строит 2–3 кандидата свободного ника на основе введённого: «ник (2)»,
 * «ник-2», «ник_2». Пустой/пробельный ник → пустой список (экран ошибки
 * в этом случае не вызывается — join не прошёл бы валидацию).
 */
export function suggestNicks(nick: string): string[] {
  const base = nick.trim();
  if (!base) return [];
  return SUFFIXES.map((suffix) => base.slice(0, MAX_NICK_LEN - suffix.length) + suffix);
}
